// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c2ba9175","453":"2e1dfb07","455":"7a0d4f82","977":"2daa58f8"}[chunkId] + ".chunk.js";
};